// TODO: 外部モジュールへの依存を消したい
import { useBrandAccountSurveysQuery } from '~/hooks/useBrandAccountSurveysQuery'
import { useCommonQueryCurrentBrandAccount } from '~/hooks/useCommonQuery'

export type { Survey } from '~/hooks/useBrandAccountSurveysQuery'

export const useCurrentBrandAccountSurveysQuery = () => {
  const currentBrandAccount = useCommonQueryCurrentBrandAccount()

  return useBrandAccountSurveysQuery(currentBrandAccount?.id)
}
